require("./variables.css");
require("./fonts.styl");

require("c8-dijit-flat-theme/flat/dijit.css");
require("c8-dijit-flat-theme/flat/document.css");
require("c8-dijit-flat-theme/flat/form/Common.css");
require("c8-dijit-flat-theme/flat/form/Button.css");
require("c8-dijit-flat-theme/flat/form/Checkbox.css");
require("c8-dijit-flat-theme/flat/form/RadioButton.css");
require("c8-dijit-flat-theme/flat/form/Select.css");
require("c8-dijit-flat-theme/flat/form/Slider.css");
require("c8-dijit-flat-theme/flat/layout/ContentPane.css");
require("c8-dijit-flat-theme/flat/layout/BorderContainer.css");
require("c8-dijit-flat-theme/flat/layout/TabContainer.css");
require("c8-dijit-flat-theme/flat/layout/AccordionContainer.css");
require("c8-dijit-flat-theme/flat/Common.css");
require("c8-dijit-flat-theme/flat/Calendar.css");
require("c8-dijit-flat-theme/flat/ColorPalette.css");
require("c8-dijit-flat-theme/flat/Dialog.css");
require("c8-dijit-flat-theme/flat/Menu.css");
require("c8-dijit-flat-theme/flat/ProgressBar.css");
require("c8-dijit-flat-theme/flat/TimePicker.css");
require("c8-dijit-flat-theme/flat/TitlePane.css");
require("c8-dijit-flat-theme/flat/Toolbar.css");
require("c8-dijit-flat-theme/flat/Tree.css");
require("c8-dijit-flat-theme/flat/icons/commonIcons.css");
require("c8-dijit-flat-theme/flat/icons/editorIcons.css");

require("csi/css/calendarPopup.styl");
require("csi/css/dgrid.styl");
require("csi/css/iconsSvg.styl");
require("csi/css/iconsFont.styl");
require("froala/css/froala_editor.min.css");
require("froala/css/froala_style.min.css");
require("froala/css/plugins/colors.min.css");
require("froala/css/plugins/draggable.min.css");
require("froala/css/plugins/emoticons.min.css");
require("froala/css/plugins/file.min.css");
require("froala/css/plugins/fullscreen.min.css");
require("froala/css/plugins/image.min.css");
require("froala/css/plugins/image_manager.min.css");
require("froala/css/plugins/line_breaker.min.css");
require("froala/css/plugins/table.min.css");
require("froala/css/plugins/char_counter.min.css");
require("froala/css/plugins/quick_insert.min.css");
require("tributejs-css/tribute.css");
require("froala/css/themes/gray.min.css");
require("csi/css/froala-editor.styl");
require("spectrum-css/spectrum.css");
require("slick-css/slick.css");
require("slick-css/slick-theme.css");
require("csi/css/attributeCard.styl");
require("csi/css/attributeCardSetup.styl");
require("csi/css/chart.styl");
require("csi/css/dateRange.styl");
require("csi/css/gridContainer.styl");
require("csi/css/lightGallery.styl");
require("csi/css/browser.styl");
require("csi/css/emailForm.styl");
require("csi/css/form.styl");
require("csi/css/gallery.styl");
require("csi/css/property.styl");
require("csi/css/table.styl");
require("csi/css/splitPane.styl");
require("csi/css/svg.styl");
require("csi/css/styles.styl");
require("csi/css/wizard.styl");
require("csi/css/imageEditor.styl");
require("csi/css/threeDViewer.styl");
require("cropper/dist/cropper.min.css");
require("csi/notification/notification.styl");
require("csi/view/ToolbarAttributesDropDown.styl");
require("csi/widget/ComboBox.styl");
require("csi/widget/ComboBoxPlaceholder.styl");
require("csi/widget/Container.styl");
require("csi/widget/CountToggle.styl");
require("csi/widget/LabeledWidget.styl");
require("csi/widget/GridSelect.styl");
require("csi/widget/ImageContainer.styl");
require("csi/widget/SortIndicator.styl");
require("csi/widget/TextWithMaterialIcon.styl");
require("csi/widget/UserCollection.styl");
require("csi/widget/UserIcon.styl");

require("Apparel/Apparel.styl");
require("AQL/AQL.styl");
require("SpecificationDataSheet/SpecificationDataSheet.styl");
require("Calendar/Calendar.styl");
require("Camunda/Camunda.styl");
require("DocumentGenerator/DGaaS.styl");
require("CollectionBook/CollectionBook.styl");
require("MultiCategoryRetail/MultiCategoryRetail.styl");
require("Operations/Operations.styl");
require("ProductPresentation/ProductPresentation.styl");
require("ProductSpec/ProductSpec.styl");
require("Proofing/Proofing.styl");
require("SiteAdmin/SiteAdmin.styl");
require("Sourcing/Sourcing.styl");
require("SourcingOrders/SourcingOrders.styl");
require("Specification/Specification.styl");
require("WBS/WBS.styl");

require("../canvas/widgets/styles/CanvasEditor.css");
require("../canvas/widgets/styles/CanvasPage.css");
require("../canvas/widgets/styles/SelectionBox.css");
